import { Injectable } from '@angular/core';
import { map, Observable, skipWhile } from 'rxjs';
import { AccessRole, AccessRoleProperties } from '../user/permissions';
import { AuthService } from './auth.service';
import { PortalService } from './portal.service';
import { convertTimestampsPipe } from '../pipes/convert-firestore-timestamp.pipe';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private ps: PortalService, private auth: AuthService) { }

  hasRole(role: AccessRole) {
    return this.auth.user$.pipe(
      map(user => {
        const accessRole = { ...AccessRoleProperties.find(accessRole => accessRole.role === role) };

        if (!accessRole || accessRole?.properties?.length === 0 || !user) {
          return false;
        }

        if (accessRole.operator === 'OR') {
          return accessRole.properties?.some(property => user && user[property]);
        }

        return accessRole.properties?.every(property => user && user[property]);
      })
    );
  }

  portalExpired(): Observable<boolean> {
    return this.ps.portal.pipe(
      skipWhile(portal => portal === null),
      map(portal => {
        return (portal?.subscriptionEnd.getTime() || 0) < Date.now();
      })
    );
  }

  reporting() {
    return this.auth.user$.pipe(
      map(user => !!user)
    );
  }

  showNpsSurvey() {
    return this.auth.user$.pipe(
      convertTimestampsPipe(),
      map(user => {
        // Check if survey has already been completed on the user
        if (user?.lastNpsSurveyCompletedDate || user?.lastNpsSurveyCompletedId) {
          return false;
        }

        const now = new Date(Date.now());
        const createdBeforeDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());

        // Check if user has been created in the past month
        if (user?.createdDate && user.createdDate > createdBeforeDate) {
          return false;
        }

        return true;

      })
    );
    // TEMP: Always show NPS survey for testing
    // Uncomment this to show NPS survey for all users, after commenting out the above return statement(Line 54 to 73)
    // return new Observable(observer => {
    //   observer.next(true);
    //   observer.complete();
    // });
  }

  editCustomSelfRegistrationLink() {
    return this.auth.user$.pipe(
      map(user => user?.hqAccess || !environment.vx || false)
    );
  }
}
